import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{
          padding: '2rem',
          fontFamily: 'monospace',
          backgroundColor: '#fef2f2',
          color: '#991b1b',
          minHeight: '100vh',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
        }}>
          <h2 style={{ marginBottom: '1rem' }}>エラーが発生しました</h2>
          <p style={{ fontWeight: 'bold' }}>{this.state.error.message}</p>
          {this.state.error.stack && (
            <pre style={{ marginTop: '1rem', fontSize: '12px', overflow: 'auto' }}>
              {this.state.error.stack}
            </pre>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              cursor: 'pointer',
            }}
          >
            再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
